import React from "react";
import { SunIcon } from "@heroicons/react/24/outline";
import SettingsSection from "../fields/SettingsSection";
import SettingsField from "../fields/SettingsField";
import RadioGroup from "../fields/RadioGroup";

export default function ThemeSection({ form, onChange }) {
  return (
    <SettingsSection
      id="appearance"
      title="Appearance"
      icon={<SunIcon className="h-5 w-5 text-primary" />}
    >
      <SettingsField
        label="Theme"
        htmlFor="theme"
        description="Choose your preferred color scheme or sync with system settings."
      >
        <RadioGroup
          name="theme"
          value={form.theme}
          onChange={(v) => onChange("theme", v)}
          options={[
            { value: "light", label: "Light" },
            { value: "dark", label: "Dark" },
            { value: "auto", label: "Auto" },
          ]}
        />
      </SettingsField>
    </SettingsSection>
  );
}
